<template>
  <div>
    <CustomPageHeaderVue>{{ $t('member_title') }}</CustomPageHeaderVue>
    <CustomRow>
      <v-card class="mt-5 cusPadding text-center">
        <v-row justify="space-around">
          <v-col cols="12" sm="6" md="2">
            <v-hover v-slot="{ hover }" open-delay="176">
              <v-card :elevation="hover ? 10 : 2" :class="{ 'on-hover': hover }" class="pa-4 mx-auto" max-width="176"
                height="100%" rounded="sm" @click="$router.push({ name: 'OrderList' })">
                <v-img src="@/assets/image/icon-member-order@3x.png" width="64" class="ma-auto" />
                <h3 class="text-title font-weight-bold mt-3">{{ $t('member_order_title') }}</h3>
                <div class="card-detail">{{ $t('member_order_description') }}</div>
              </v-card>
            </v-hover>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-hover v-slot="{ hover }" open-delay="176">
              <v-card :elevation="hover ? 10 : 2" :class="{ 'on-hover': hover }" class="pa-4 mx-auto" max-width="176"
                height="100%" rounded="sm" @click="$router.push({ name: 'Ticket' })">
                <v-img src="@/assets/image/icon_ticket.svg" width="64" class="ma-auto" />
                <h3 class="text-title font-weight-bold mt-3">{{ $t('ticket_box_entry_title') }}</h3>
                <div class="card-detail">{{ $t('ticket_box_entry_content') }}</div>
              </v-card>
            </v-hover>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-hover v-slot="{ hover }" open-delay="176">
              <v-card :elevation="hover ? 10 : 2" :class="{ 'on-hover': hover }" class="pa-4 mx-auto hoverCard"
                max-width="176" height="100%" rounded="sm" @click="$router.push({ name: 'UserInfo' })">
                <v-img src="@/assets/image/icon-member-info@3x.png" width="64" class="ma-auto" />
                <h3 class="text-title font-weight-bold mt-3">{{ $t('member_userinfo_title') }}</h3>
                <div class="card-detail">
                  {{ $t('member_userinfo_description') }}
                </div>
              </v-card>
            </v-hover>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-hover v-slot="{ hover }" open-delay="176">
              <v-card :elevation="hover ? 10 : 2" :class="{ 'on-hover': hover }" class="pa-4 mx-auto" max-width="176"
                height="100%" rounded="sm" @click="$router.push({ name: 'Contactus' })">
                <v-img src="@/assets/image/icon-contact-us@3x.png" width="64" class="ma-auto" />
                <h3 class="text-title font-weight-bold mt-3">{{ $t('member_contact_title') }}</h3>
                <div class="card-detail">
                  {{ $t('member_contact_description') }}
                </div>
              </v-card>
            </v-hover>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-hover v-slot="{ hover }" open-delay="176">
              <v-card :elevation="hover ? 10 : 2" :class="{ 'on-hover': hover }" class="pa-4 mx-auto" max-width="176"
                height="100%" rounded="sm" @click="$router.push({ name: 'Terms' })">
                <v-img src="@/assets/image/icon-law-term@3x.png" width="64" class="ma-auto" />
                <h3 class="text-title font-weight-bold mt-3">{{ $t('member_terms_title') }}</h3>
                <div class="card-detail">
                  {{ $t('member_terms_description') }}
                </div>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-card>
    </CustomRow>
  </div>
</template>

<script>
import CustomPageHeaderVue from '@/components/CustomPageHeader.vue';
export default {
  components: { CustomPageHeaderVue },
  metaInfo() {
    return {
      title: `${this.$t('member_title')} - ${this.$t('app_name')}`,
      meta: [
        {
          property: 'og:title',
          content: `${this.$t('member_title')} - ${this.$t('app_name')}`,
          vmid: 'og:title'
        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        }
      ],
      script: [{
        type: 'application/ld+json',
        json: {
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": `${this.$t('member_title')} - ${this.$t('app_name')}`,
          "url": window.location.href
        }
      }]
    }
  },
  mounted() {
    setTimeout(() => {
      this.$gtm.trackView(`會員專區`, this.$route.path);
      this.$store.dispatch("setOverlayLoading", false);
    }, 200);
  },
}
</script>
<style lang="scss" scoped>
.cusPadding {
  border-radius: $radiusDesktop;
  padding: 60px 48px 150px;

  @media screen and (max-width: 600px) {
    border-radius: $radiusMobile;
  }
}

.card-detail {
  height: 40px;
  font-size: 0.7rem;
  color: $grey-darken-3;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
